import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const propertyService = {
  getProperties,
  viewProperty,
  storeOrUpdateProperties,
  getListUsersOfProperty,
  inviteUser,
  cancelInviteUser,
  getAllProperties,
  active,
  activateSharingMap,
  viewPropertyByToken,
  updateDeviceTime,
  getStripePortalUrl,
  getPropertyMetaByToken,
  requestFreeSetup,
  getGeneralStatistic,
  getPaginatedProperties,
  getOptionProperty,
  getPropertySetting,
  updatePropertySetting,
  approveContractor,
  getMenuConfig,
  updateMenuConfig,
  updateMapSettings,
  getUsersFromMultipleProperties,
  updateUserManager,
  setSelectedProperty,
  adoptCheckInForm,
  getCheckInForms,
  updateCheckInForm,
  deleteCheckInForm,
  setPrimaryCheckInForm,
  setContractorSignInForm,
  requestPropertyAccess,
  getPendingAccess,
};

function getProperties(is_paginated = false, page = 1, pageSize = 10,searchInput = ''){
  return (
    axios
    .get(
        `${apiEndpoint.properties}?is_paginated=${is_paginated}&page=${page}&page_size=${pageSize}&search=${searchInput}`,
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return [];
    })
  );
}
function getOptionProperty(page=1){
  return (
    axios
    .get(
        `${apiEndpoint.properties}/get-option-property?page=${page}`,
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return [];
    })
  );
}

function getPropertySetting(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.properties}/get-property-setting?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function updatePropertySetting(propertyId, data){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/update-property-setting`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function approveContractor(propertyId, userId){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/approve-contractor`,
        { user_id: userId },
        {
          headers: authHeader(),
        }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}


// --- Per-property check-in form adoption + management (Phase 6) ---
// Routes live under the plural /properties/{id}/... base (verified auth-gated).

function adoptCheckInForm(propertyId, globalFormId){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/check-in-forms/adopt`,
        { global_form_id: globalFormId },
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function updateCheckInForm(propertyId, formId, data){
  return (
    axios
      .put(
        `${apiEndpointFunction.properties(propertyId)}/check-in-forms/${formId}`,
        data,
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

// `force` is the second confirmation for a form that already has submissions —
// without it the API refuses and reports how many there are, so the UI can say
// exactly what is being taken out of use before asking again.
function deleteCheckInForm(propertyId, formId, force = false){
  return (
    axios
      .delete(
        `${apiEndpointFunction.properties(propertyId)}/check-in-forms/${formId}${force ? '?force=1' : ''}`,
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

// The property's forms plus its two Primary pointers — and nothing else. The
// Property Forms tab used viewProperty() for this, which also serializes the
// property's users, primary objects, metas and hosts to deliver three fields.
function getCheckInForms(propertyId){
  return (
    axios
      .get(
        `${apiEndpointFunction.properties(propertyId)}/check-in-forms`,
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function setPrimaryCheckInForm(propertyId, formId){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/check-in-forms/${formId}/set-primary`,
        {},
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function setContractorSignInForm(propertyId, formId){
  return (
    axios
      .put(
        `${apiEndpointFunction.properties(propertyId)}/contractor-sign-in-form`,
        { form_id: formId },
        { headers: authHeader() }
      )
      .then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function storeOrUpdateProperties(data, id = null){
  return (id ? (
    axios
      .put(
        apiEndpointFunction.properties(id),
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        apiEndpoint.properties,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if(res && res.status === 200){
      return res.data;
    }
    return {};
  });
}

function viewProperty(id){
  return (
    axios
      .get(
        apiEndpointFunction.properties(id),
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getGeneralStatistic(){
  return (
    axios
      .get(
        `${apiEndpoint.properties}/get-general-statistic`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

// options.includeCorporateGroup: also return users of the other properties in
// this property's corporate group (each carries `property_name`).
function getListUsersOfProperty(propertyId, isAllInvitedUsers = false, excludePermission = [], options = {}){
  return (
    axios
      .get(
        `${apiEndpoint.users}?property_id=${propertyId}${isAllInvitedUsers ? '&is_all_invited_users=1' : ''}${options.includeCorporateGroup ? '&include_corporate_group=1' : ''}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          let users = res.data.users.map(user => {
            return {
              ...user,
              id: user.id,
              name: user.name,
              email: user.email,
              mobile_phone: user.mobile_phone,
              permission: user.more_info.permission,
              permission_id: user.more_info.permission_id,
              user_property_id: user.more_info.user_property_id,
              status: user.more_info.status,
              status_label: user.more_info.status ? 'Accepted' : 'Pending',
              invited_token: user.more_info.invited_token,
              access_requested: !!user.more_info.access_requested,
              permission_slug: user.more_info.permission_slug,
              invitation_link: user.more_info.invitation_link,
              manager_id: user.more_info.manager_id,
              manager_name: user.more_info.manager_name,
              // Whether this account has a contractor check-in on this property
              // linked to it — drives the Source tag on the Contractors tab.
              from_checkin: user.more_info.from_checkin,
              // NOTE: more_info is flattened field by field here, so anything
              // added to it server-side must also be listed here or it silently
              // arrives as undefined in the tables.
              contractor_business_name: user.more_info.contractor_business_name,
            }
          });
          if (excludePermission.length > 0) {
            const exclude = new Set(excludePermission.map((s) => String(s).toLowerCase()));
            users = users.filter(
              (u) => !exclude.has(String(u.permission_slug || '').toLowerCase())
            );
          }
          return {
            users: users,
            code: res.data.code,
          };
        }
        return {};
      })
  );
}

function inviteUser(id, data){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(id)}/invite`,
        data,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function requestFreeSetup(id){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(id)}/send-free-setup-request`,
        {},
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function cancelInviteUser(id, userId){
  return (
    axios
      .get(
        `${apiEndpointFunction.properties(id)}/cancel-invite`,
        {
          headers: authHeader(),
          params: {
            user_id: userId
          }
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getAllProperties(){
  return (
    axios
      .get(
        `${apiEndpoint.properties}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function active(id){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(id)}/active`,
        null,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function activateSharingMap(id, data){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(id)}/activate-sharing-map`,
        data,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function updateDeviceTime(id,data){
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(id)}/update-device-time`,
        data,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function viewPropertyByToken(token = ''){
  return (
    axios
      .get(
        `${apiEndpoint.properties}/view-property-by-token?token=${token}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getStripePortalUrl(id){
  return (
    axios
      .get(
        `${apiEndpoint.properties}/${id}/get-stripe-portal-url`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getPropertyMetaByToken(token){
  return (
    axios
    .get(
      `${apiEndpoint.properties}/get-property-meta-by-token?token=${token}`,
      {
        headers: authHeader()
      }
    )
    .then(res => {
      if(res && res.status === 200){
        return res.data;
      }
      return [];
    })
  );
}

function getPaginatedProperties(page = 1, limit = 10, search = '') {
  return (
    axios
      .get(
        `${apiEndpoint.paginatedProperties}?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getMenuConfig(propertyId) {
  return (
    axios
      .get(
        `${apiEndpoint.properties}/get-menu-config?property_id=${propertyId}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

// Map display settings live on the property, not the user: everyone who opens
// the property's maps sees them drawn the same way.
function updateMapSettings(propertyId, showEdgeDistance) {
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/update-map-settings`,
        { map_show_edge_distance: showEdgeDistance ? 1 : 0 },
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function updateMenuConfig(propertyId, hiddenItems) {
  return (
    axios
      .post(
        `${apiEndpointFunction.properties(propertyId)}/update-menu-config`,
        { hidden_items: hiddenItems },
        {
          headers: authHeader(),
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
        return {};
      })
  );
}

function getUsersFromMultipleProperties(propertyIds) {
  const params = propertyIds.map(id => `property_ids[]=${id}`).join('&');
  return (
    axios
      .get(
        `${apiEndpoint.users}/get-users-by-property-ids?${params}`,
        {
          headers: authHeader(),
        }
      ).then(res => {
        if (res && res.status === 200 && res.data.code === '0000') {
          return { users: res.data.users || [], code: res.data.code };
        }
        return { users: [], code: res.data?.code || '1001' };
      })
  );
}

function setSelectedProperty(activePropertyId) {
  return (
    axios
      .post(
        `${apiEndpoint.propertySelect}/property`,
        { active_property_id: activePropertyId },
        {
          headers: authHeader(),
        }
      ).then(res => {
        if (res && res.data && res.data.success) {
          return res.data;
        }
        return {};
      })
  );
}

function updateUserManager(userPropertyId, managerId) {
  return (
    axios
      .put(
        apiEndpointFunction.permissions(userPropertyId),
        { manager_id: managerId },
        {
          headers: authHeader(),
        }
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }
        return {};
      })
  );
}

// Onboarding: ask for read-only access to a property by its code, which an
// owner/admin always has to accept.
function requestPropertyAccess(publishCode){
  return axios
    .post(`${apiEndpoint.properties}/access-request`, { publish_code: publishCode }, { headers: authHeader() })
    .then(res => (res && res.status === 200 ? res.data : {}));
}

// Onboarding: the current user's own memberships still waiting on approval or
// acceptance, which the property list leaves out.
function getPendingAccess(){
  return axios
    .get(`${apiEndpoint.properties}/pending-access`, { headers: authHeader() })
    .then(res => (res && res.status === 200 ? res.data : {}));
}
